export function formatFirstName(value) {
  if (!value || typeof value !== 'string') return value
  return value
    .toLowerCase()
    .replace(/(^|[\s-])\S/g, (c) => c.toUpperCase())
}

export function formatLastName(value) {
  if (!value || typeof value !== 'string') return value
  return value.toUpperCase()
}
